import React, { useState, useEffect } from 'react'
// import LoadingDots from '../../Shared/LoadingDots'
import { taskOperationsService } from '../../../_services/taskOperations.service'
import moment from 'moment-jalaali'
import TaskCode from '../../Shared/TaskCode'
import { Print } from './Print'
// import Loading from '../../Shared/Loading'
import PageSize from '../../Shared/PageSize'
import ReactPaginate from 'react-paginate'

const History = (props) => {
  const [loading, setLoading] = useState(true)
  const [showPrintDialog, setShowPrintDialog] = useState(false)
  const [model, setModel] = useState(undefined)
  const [data, setData] = useState([])
  const [unitId, setUnitId] = useState(props.unitId)
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(parseInt(localStorage.getItem('pageSize'), 0) || 10)
  const [dto, setDto] = useState({ page: page, pageSize: pageSize, unitId: props.unitId, sorted: { id: "updatedAt", desc: false } })

  useEffect(() => {

    if (props.unitId) {
      setUnitId(props.unitId)
    }

    getData()

  }, [props.unitId, pageSize, page])

  const getData = () => {

    setLoading(true)

    let newDto = dto;
    newDto["pageSize"] = pageSize;
    newDto["page"] = page;
    newDto["unitId"] = unitId;
    newDto["sorted"] = dto.sorted;

    console.log(JSON.stringify(newDto));

    taskOperationsService.getAllHistory(JSON.stringify(newDto))
      .then((res) => {
        console.log(res.data)
        setData(res.data)
        setLoading(false)
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
      });

  }

  const handlePrintModalShow = (taskId) => {

    setModel(taskId)

    setShowPrintDialog(true)
  }

  const handlePageClick = e => {
    let page_ = e.selected;
    // let offset = Math.ceil(currentPage * this.props.perPage);
    console.log(page_);

    setPage(page_)

  };

  return (
    data.data && data.data.length > 0 && !loading ?
      <>
        <table className="table validator-table">
          <thead>
            <tr>
              <th className="text-center">ردیف</th>
              <th className="text-center">کد سفارش</th>
              <th className="text-center">دسته بندی</th>
              <th className="text-center">برند</th>
              <th className="text-center">نام کالا</th>
              <th className="text-center">تاریخ آخرین بروزرسانی</th>
              <th className="text-center">شیفت</th>
            </tr>
          </thead>
          <tbody>
            {data.data && data.data.map((item, index) => (
              <tr key={"p-" + index} style={{ height: 70, background: item.unitTaskStatus === 2 ? '#42f3be' : 'unset' }} onClick={() => handlePrintModalShow(item.id)} className="pointer">
                <td>{(page * pageSize) + index + 1}</td>
                <td>
                  <TaskCode code={item.task && item.task.taskCode} />
                </td>
                <td>
                  {item.task && item.task.product && item.task.product.category.name}
                </td>
                <td>
                  {item.task && item.task.product && item.task.product.brand.name}
                </td>
                <td>
                  {item.task && item.task.product && item.task.product.name}
                </td>
                <td>
                  {item.task && item.task.createdAt && moment(item.updatedAt, "YYYY/M/D H:m").format("jYYYY/jM/jD ساعت H:mm")}
                </td>
                <td className="text-center">
                  <div className="shift">{item.shift}</div>
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan="6">
                <div className={data.totalPage > 1 ? "text-center" : "hidden"}>
                  <ReactPaginate
                    previousLabel={'‹'}
                    nextLabel={'›'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={data.totalPage}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    forcePage={page}
                  />
                </div>
              </td>
              <td>
                <div className={data.totalPage > 1 ? "text-center" : "hidden"}>
                  <PageSize
                    value={pageSize} defaultValue={pageSize}
                    onChange={(val) => {
                      setPage(0)
                      setPageSize(val)
                      localStorage.setItem('pageSize', val)

                    }} />
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <Print taskOperationsId={model} show={showPrintDialog} onClose={() => setShowPrintDialog(false)} />
      </>
      :
      unitId && !loading ?
        <div className="text-center" style={{ padding: 20 }}>موردی برای نمایش یافت نشد</div>
        : <div className="text-center" style={{ padding: 20 }}>لطفا صبر کنید</div>

  )
}

export default History;